const executeHeadHunters = async ({
    worldContract,
    smartObjectId,
    quantity,
    itemId,
    smartCharacterName,
  }: {
    worldContract: any;
    smartObjectId: string;
    quantity: number;
    itemId: number;
    smartCharacterName: string;
  }): Promise<string | undefined> => {
    let txHash;
  
    txHash = await worldContract.write.Tapticc__executeHeadHunters([smartObjectId, quantity, itemId, smartCharacterName]);

    return txHash;
  };
  
  export default executeHeadHunters;
